import { useLayoutEffect as $useLayoutEffect } from 'react';
export const useLayoutEffect = typeof document === 'undefined' ? () => { } : $useLayoutEffect;
//# sourceMappingURL=useLayoutEffect.js.map